@if (application(); as application) {
  <div class="application-details">
    <div class='row'>
      <div class='col-md-3'>
        <app-label label='Data utworzenia:'>
          {{ application?.createdAt | date }}
        </app-label>
      </div>
      <div class='col-md-3'>
        <app-label label='Data zatwierdzenia:'>
          {{ application?.updatedAt | date }}
        </app-label>
      </div>
      <div class='col-md-6'>
        <app-label label='Numer sprawy:'>
          {{ application?.caseNumber || '-' }}
        </app-label>
      </div>
    </div>
    <ng-container *ngIf='shipments()?.length'>
      <br>
      <app-decision-data-preview [canPay]="canPay()" [shipments]="shipments()">
      </app-decision-data-preview>
      <br>
    </ng-container>
    <app-applicant-preview
      [application]="application"
      [expanded]="expanded">
    </app-applicant-preview>
    <br>
    <h3>
      Dane wniosku
    </h3>
    <app-application-data-preview [application]="application">
    </app-application-data-preview>
    <br>
    <h3>
      Dane nieruchomości
    </h3>
    <div class="row">
      <div class='col-md-4'>
        <app-label label='Miejscowość:'>
          {{ application?.city || '-' }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='Ulica:'>
          {{ application?.street || '-' }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='Nr domu:'>
          {{ application?.houseNumber || '-' }}
        </app-label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <app-label label="Kod pocztowy:">
          {{ application?.postalCode || '-' }}
        </app-label>
      </div>
      <div class="col-md-4">
        <app-label label="Nr działki:">
          {{ application?.registrationNumber || '-' }}
        </app-label>
      </div>
      <div class="col-md-4">
        <app-label label="Obręb ewidencyjny:">
          {{ application?.precint || '-' }}
        </app-label>
      </div>
    </div>
    <br>
    <h3>
      Charakterystyka inwestycji
    </h3>
    <div class="row">
      <div class="col-12">
        <app-label label="Nazwa inwestycji oraz łączna ilość obiektów:">
          {{ application?.investmentNameAndTotalObjects || '-' }}
        </app-label>
      </div>
    </div>
    <br>
    <p class="mb-2">
      <strong>Parametry dotyczące terenu inwestycji</strong>
    </p>
    <div class="row">
      <div class="col-md-3">
        <app-label label="Wysokość całkowita <br> obiektu:">
          {{ (application?.maxBuildingHeight | number) || '-' }} (cm)
        </app-label>
      </div>
      <div class="col-md-3">
        <app-label label="Szerokość <br> obiektu:">
          {{ (application?.width | number) || '-' }} (cm)
        </app-label>
      </div>
      <div class="col-md-3">
        <app-label label="Grubość <br> obiektu:">
          {{ (application?.thickness | number) || '-' }} (cm)
        </app-label>
      </div>
      <div class="col-md-3">
        <app-label label="Powierzchnia ekspozycji <br> wymiary:">
          {{ (application?.area | number) || '-' }} (cm<sup>2</sup>)
        </app-label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <app-label label="Wysokość dolnej krawędzi powierzchni ekspozycji od <br> poziomu terenu:">
          {{ (application?.height | number) || '-' }} (cm)
        </app-label>
      </div>
      <div class="col-md-4">
        <app-label label="Odległość od <br> najbliższego budynku:">
          {{ (application?.distance | number) || '-' }} (cm)
        </app-label>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <app-label label="Sposób montażu do gruntu/na elewacji/w witrynie:">
          {{ application?.groundMountingMethod || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Materiały budowlane z jakich wykonany jest obiekt oraz jego kolor:">
          {{ application?.buildingMaterialsAndColor || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Dostęp do energii elektrycznej:">
          {{ application?.electricityAccessDescription || '-' }}
        </app-label>
      </div>
    </div>
    <br>
    <p class="mb-2">
      <strong>
        Łączna powierzchnia sprzedaży/użytkowa w metrach kwadratowych, w przypadku gdy inwestycja
        towarzyszy wolnostojącym obiektom handlowym/gastronomicznym
      </strong>
    </p>
    <div class="row">
      <div class="col-md-4">
        <app-label label="Łączna powierzchnia">
          {{ application?.totalSalesOrUsableArea }} (m<sup>2</sup>)
        </app-label>
      </div>
    </div>
    <br>
    <h3>
      Zgody
    </h3>
    <app-agreements-data-preview [application]="application">
    </app-agreements-data-preview>
    <br>
    <h3>
      Załączniki
    </h3>
    <app-attachments-data-preview [application]="application">
    </app-attachments-data-preview>
  </div>
}
